import { createContext, useContext } from 'react';

import type { SharedSideNavLabels, SideNavRegionAttributes } from './types';

export interface SideNavContextValue {
  labels: SharedSideNavLabels;
  onActivate: (key: string) => void;
  regionAttributes: SideNavRegionAttributes;
  activeKey?: string | null;
  /** Pin state and its toggle. Unset hides the pin controls. */
  pinControl?: {
    isPinned: (key: string) => boolean;
    onToggle: (key: string) => void;
  };
}

export const SideNavContext = createContext<SideNavContextValue | undefined>(
  undefined,
);

/** Reads the enclosing `SideNav`'s shared wiring. Throws outside a `SideNav`. */
export function useSideNavContext(): SideNavContextValue {
  const context = useContext(SideNavContext);
  if (!context) {
    throw new Error('SideNav subcomponents must render inside a SideNav.');
  }
  return context;
}
